import React from 'react';
import { useTracking } from '../Tracking';
import { TextLink } from '@spotify-internal/encore-web';

type Props = {
  href: React.ReactNode;
  children: React.ReactNode;
  category?: string;
  label?: string;
};

export const ExternalLink = (props: Props) => {
  const { sendEvent } = useTracking();
  const onClick = props.label
    ? () =>
        sendEvent({
          eventAction: 'click',
          eventCategory: props.category || 'External Link',
          eventLabel: props.label || '',
        })
    : null;

  const tagProps = { ...props };
  delete tagProps.label;

  return (
    <TextLink
      {...tagProps}
      href={props.href as $TSFixMe}
      onClick={onClick as $TSFixMe}
      target="_blank"
      rel="noopener noreferrer"
    >
      {props.children}
    </TextLink>
  );
};
